import { track } from 'lib/babylistHealthAnalytics'
import { decorateEventPayload } from './decorateEventPayload'

export const preCheckoutModalViewedEvent = (tracker: any) => () => {
  const payload = decorateEventPayload({
    event: track.dmePreCheckoutModalViewed,
  })
  tracker.trackEvent(payload)
}
